import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { deleteDiscussion, getEachDiscussion } from '../../redux/Thunks/discussionsThunk'
import EachDiscussionActivity from './EachDiscussionActivity'
import { userInfo } from '../../redux/Selectors/selectors'
import { BiDotsVerticalRounded } from "react-icons/bi"
import { toast } from 'react-toastify'


const DiscussionsBoard = () => {

    const { discussion_id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const user = useSelector(state => userInfo(state))
    const [toggleMore, setToggleMore] = useState(false)
    const discussionData = useSelector(state => state.discussions.oneDiscussion)


      const deleteDiscussionItem = async (id) => {
          const response = await dispatch(deleteDiscussion({eid : id, user_id : user?.id })).unwrap()
    
          if(response?.message){
            toast.success(response?.message)
            await new Promise(resolve => setTimeout(resolve, 1500))
            navigate("/dashboard")
          }else{
            toast.error("Ooops, something went wrong.")
          }
    
      }


    useEffect(() => {
        dispatch(
          getEachDiscussion({
            discussion_id,
          })
        )

      },[discussion_id, dispatch])




  return (
    <div 
    onClick={() => {
      if(toggleMore){
        setToggleMore(false)
      }
        
     }}
    className=' relative w-full md:w-2/3 max-h-screen rounded-lg bg-[#202020]'>
    <div className='m-4 p-2 md:p-5'>
    <div className='w-full'>
      <h1 className='font-nunito font-bold text-2xl '>Welcome to Discussions</h1>
    </div>

     {discussionData ? (
         <EachDiscussionActivity
          discussion_id={discussion_id}
          description={discussionData?.description}
          title={discussionData?.title}
          author={discussionData?.author.username}
          authorID={discussionData?.author.id}
          author_image={discussionData?.author.user_image}
         />

     ) : (
      <div
            className="my-4 animate-spin rounded-full h-16 w-16
            border-t-4 border-[#3C6E71]"></div>
     ) }
    </div>

            {discussionData?.author?.id === user?.id
            &&
            <div className='absolute right-3 top-3'>
              <button onClick={ () => setToggleMore(!toggleMore)}>
              <BiDotsVerticalRounded  className='text-white text-2xl'/>
              </button>
              {toggleMore && 
                <div className='flex flexcol justify-center items-center absolute top-5 right-4 z-[3]
               bg-white h-[40px] w-[120px] rounded-md text-black'>
                  <button 
                  onClick={() => deleteDiscussionItem(discussionData?.eid)}
                  className='transition-all ease-linear hover:translate-x-[5px] 
                  w-full font-semibold text-red-600'>delete</button>
              </div>
              }
    
            </div>
            }


    </div>
  )
}

export default DiscussionsBoard
